const Flickity = require("flickity");

Flickity.prototype._createResizeClass = function() {
  this.element.classList.add('flickity-resize');
};

Flickity.createMethods.push('_createResizeClass');

let flickityResize = Flickity.prototype.resize;

Flickity.prototype.resize = function() {
  this.element.classList.remove('flickity-resize');
  flickityResize.call(this);
  this.element.classList.add('flickity-resize');
};

const $ = window.jQuery;

const enableCarousel = (container) => {
  const options = $.extend({
    imagesLoaded: true,
    wrapAround: true
  }, $(container).data("carouselOptions"));

  $(container).addClass("carousel-pre-init");

  const flkty = new Flickity(container, options);

  $(container).imagesLoaded().always(() => {
    flkty.resize();
  });
};

jQuery(document).ready($ => {
  $(".js-carousel").each((i, el) => {
    enableCarousel(el);
  });
});
